var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    staticClass: "file-input",
    attrs: {
      "label": _vm.label,
      "errors": _vm.internalErrors
    },
    on: {
      "focus": _vm.focus
    }
  }, [_c('div', {
    attrs: {
      "uk-form-custom": "target: true"
    }
  }, [_c('input', {
    ref: "primaryInput",
    attrs: {
      "type": "file",
      "disabled": _vm.disabled,
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.selectFiles
    }
  }), _vm._v(" "), _c('input', {
    ref: "dummy",
    staticClass: "uk-input dummy-input",
    class: _vm.inputCss,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "readonly": ""
    }
  })]), _vm._v(" "), _c('common-button', {
    attrs: {
      "icon": "trash"
    },
    on: {
      "click": _vm.clearFile
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268b5243","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/FileInput.vue
// module id = 1908
// module chunks = 0